import onMapIcon from '../../../../assets/isuzu/icon/on_map.svg';
import phoneIcon from '../../../../assets/isuzu/icon/phoneIcon.svg';
import phoneIconBlack from '../../../../assets/isuzu/icon/phoneIconBlack.svg';
import chevronDownIcon from '../../../../assets/isuzu/icon/chevron-down.svg';
import docExtension from '../../../../assets/isuzu/icon/extension.svg';
import isuPoiActive from '../../../../assets/isuzu/icon/isu-poi-active.svg';
import isuPoiActiveWhiteFilled from '../../../../assets/isuzu/icon/isu-poi-active-white-filled.svg';
import isuPoiInactive from '../../../../assets/isuzu/icon/isu-poi-inactive.svg';
import isuCommercialCarsSalesIcon from '../../../../assets/isuzu/icon/services/commercialsales.svg';
import isuCommercialCarsServiceIcon from '../../../../assets/isuzu/icon/services/service.svg';
import isuExclusiveAmperaIcon from '../../../../assets/isuzu/icon/services/carosserie.svg';
import isuPaintAndBodyRepairIcon from '../../../../assets/isuzu/icon/services/paintandbodyrepair.svg';
import isuPassengerCarsSalesIcon from '../../../../assets/isuzu/icon/services/passengercarsales.svg';
import isuPartsStoreIcon from '../../../../assets/isuzu/icon/services/parts.svg';
import isuUsedCarsIcon from '../../../../assets/isuzu/icon/services/usedcars.svg';
import isuDefaultServiceIcon from '../../../../assets/isuzu/icon/services/default_service_icon.svg';
import noImagePlaceholder from '../../../../assets/common/no-image-placeholder.png';
import plusIcon from '../../../../assets/isuzu/icon/plus.svg';
import minusIcon from '../../../../assets/isuzu/icon/minus.svg';
import isuPhoneIcon from '../../../../assets/isuzu/icon/phone.svg';
import chevronRight from '../../../../assets/isuzu/icon/chevron-right.svg';
import chevronLeft from '../../../../assets/isuzu/icon/chevron-left.svg';
import closeIcon from '../../../../assets/isuzu/icon/close_icon24x24.svg';
import backArrowIcon from '../../../../assets/isuzu/icon/back_arrow.svg';
import isuCalendar from '../../../../assets/isuzu/icon/calendrier_50x50.svg';
import blueCheckMarkIcon from '../../../../assets/isuzu/icon/blue-check-mark.svg';
import infoIcon from '../../../../assets/isuzu/icon/info-icon.svg';
import popupCloseIcon from '../../../../assets/isuzu/icon/popup_close_icon24x24.svg';
import breadcrumbArrow from '../../../../assets/isuzu/icon/breadcrumb-arrow.svg';
import buttonArrowRight from '../../../../assets/isuzu/icon/button-arrow-right.svg';
import timeIcon from '../../../../assets/isuzu/icon/time.svg';
import wltpIcon from '../../../../assets/isuzu/icon/wltp.svg';

import formDateInput from '../../../../assets/isuzu/icon/form-date-input.svg';
import formTimeInput from '../../../../assets/isuzu/icon/form-time-input.svg';

import deleteIcon from '../../../../assets/isuzu/icon/delete.svg';

export const isuAssets = Object.freeze({
  isuPoiActive,
  isuPoiActiveWhiteFilled,
  isuPoiInactive,
  onMapIcon,
  phoneIcon,
  phoneIconBlack,
  isuCommercialCarsSalesIcon,
  isuCommercialCarsServiceIcon,
  isuExclusiveAmperaIcon,
  isuPaintAndBodyRepairIcon,
  isuPassengerCarsSalesIcon,
  isuPassengerCarsServiceIcon: isuCommercialCarsServiceIcon,
  isuPartsStoreIcon,
  isuDefaultServiceIcon,
  isuUsedCarsIcon,
  chevronDownIcon,
  docExtension,
  noImagePlaceholder,
  plusIcon,
  minusIcon,
  isuPhoneIcon,
  chevronRight,
  chevronLeft,
  closeIcon,
  backArrowIcon,
  isuCalendar,
  blueCheckMarkIcon,
  breadcrumbArrow,
  buttonArrowRight,
  infoIcon,
  popupCloseIcon,
  timeIcon,
  wltpIcon,
  formDateInput,
  formTimeInput,
  deleteIcon,
});
